<template>
    <div>
        <template v-if="viewPage == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Company Profile </h1>
            </div>
            <div class="company-main">
                <div class="company-profile-form">
                    <div class="company-profile-head mb-3 clearfix">
                        <div class="profile-image">
                            <div v-if="form.image == null" id="image-preview" class="user-image-holder" :style="'background: url('+this.$global.base_url+'images/table-dummy-image.jpg); '">
                                <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                            </div>
                            <div v-else-if="form.image != null" id="image-preview" class="user-image-holder" :style="'background: url('+'/avatar/'+this.form.image+');'">
                                <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                            </div>
                            <div v-else id="image-preview" class="user-image-holder" :style="'background: url('+preview+');'">
                                <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                            </div>
                            <span class="update-image">
                                <i class="fas fa-pencil-alt"></i>
                            </span>
                        </div>
                        <div class="profile-title">
                            <h2>
                                <input type="text" disabled="true" name="name" placeholder="Company Name" v-model="form.name" class="form-control">
                            </h2>
                        </div>
                    </div>
                    <form>
                      <div class="row col-md-4 pb-3" >
                        <label class="label block-label"> Account Number  <em class="required">*</em> </label>
                        <input type="text" disabled="" class="form-control" name="walletID" v-model="form.walletID" />
                      </div>
                        <div class="form-group">
                            <div class="row col-md-6">
                                <label>Hierarchy System</label>
                                <select class="form-control selectpicker custom-select2" @change="saveCompanyMakerCheckerApprover($event)" name="heirarchy_system" v-model="heirarchy_system">
                                    <option value="ENABLED">ENABLED</option>
                                    <option value="DISABLED">DISABLED</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row mb-2">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>No. of Maker(s)</label>
                                        <input type="number" min="1" name="no_of_maker" disabled="true" v-model="form.no_of_maker" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" style="display: none;" @click.prevent="submitMCA($event,1)" class="save"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>No. of Checker(s)</label>
                                        <input type="number" min="1" name="no_of_checker" disabled="true" v-model="form.no_of_checker" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" class="save" style="display: none;" @click.prevent="submitMCA($event,2)"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>No. of Approver(s)</label>
                                        <input type="number" min="1" name="no_of_approver" disabled="true" v-model="form.no_of_approver" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" class="save" style="display: none;" @click.prevent="submitMCA($event,3)"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2" v-show="heirarchy_system == 'ENABLED'">
                                <div class="col-md-4 maker">
                                </div>
                                <div class="col-md-4 checker">
                                </div>
                                <div class="col-md-4 approver">
                                </div>
                            </div>
                        </div>
                    </form>
                    <form @submit.prevent="">
                        <div class="form-group">
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <label>Income Tax</label>
                                    <select class="selectpicker custom-select2" name="incomeTaxModule" v-model="form.incomeTaxModule" @change="saveCompanyProfile($event)">
                                        <option value="ENABLED">ENABLED</option>
                                        <option value="DISABLED">DISABLED</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label>Provident Fund</label>
                                    <select class="selectpicker custom-select2" name="providentFundModule" v-model="form.providentFundModule" @change="saveCompanyProfile($event)">
                                        <option value="ENABLED">ENABLED</option>
                                        <option value="DISABLED">DISABLED</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-show="form.providentFundModule == 'ENABLED'">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>PF percenatge on basic salary</label>
                                        <input type="text" disabled="true" name="pf_per_gross_salary" placeholder="PF percenatge on basic salary" v-model="form.pf_per_gross_salary" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" class="save" style="display: none;" @click.prevent="saveCompanyProfile($event)"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Company contribution on gross salary</label>
                                        <input type="text" disabled="true" name="company_contribution_gross_salary" placeholder="Percentage of gross salary" v-model="form.company_contribution_gross_salary" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" class="save" style="display: none;" @click.prevent="saveCompanyProfile($event)"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Company Contribution After Year</label>
                                        <input type="text" disabled="true" name="pf_after_year" placeholder="Company Contribution After Year[s]" v-model="form.pf_after_year" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" class="save" style="display: none;" @click.prevent="saveCompanyProfile($event)"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Company Contribution After Month</label>
                                        <input type="text" disabled="true" name="pf_after_month" placeholder="Company Contribution After Month[s]" v-model="form.pf_after_month" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" class="save" style="display: none;" @click.prevent="saveCompanyProfile($event)"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <div>
                                        <label>Shift</label>
                                        <select class="selectpicker custom-select2" name="shifts" v-model="form.shifts" @change="saveCompanyProfile($event)">
                                            <option value="ENABLED">ENABLED</option>
                                            <option value="DISABLED">DISABLED</option>
                                        </select>
                                        <p v-if="form.shifts == 'ENABLED'"><router-link to="/newShifts">Click here</router-link> to add shift</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                    <label>Overtime</label>
                                    <select class="selectpicker custom-select2" name="overtime" v-model="form.overtime" @change="saveCompanyProfile($event)">
                                        <option value="ENABLED">ENABLED</option>
                                        <option value="DISABLED">DISABLED</option>
                                    </select>
                                    </div>
                                </div>
                                
                                <div class="col-md-6" v-if="form.overtime == 'ENABLED'">
                                    <div class="form-group">
                                        <label>Overtime Hour(x)</label>
                                        <input type="text" disabled="true" name="overtime_percentage" step="0.1" v-model="form.overtime_percentage" class="form-control">
                                    </div>
                                    <div class="action-buttons">
                                        <a href="#" class="edit"><i class="fas fa-pencil-alt"></i></a>
                                        <a href="#" class="save" style="display: none;" @click.prevent="saveCompanyProfile($event)"><i class="far fa-save"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-6">
                                    <div>
                                    <label>Rreprocess Failed Batch </label>
                                    <select class="selectpicker custom-select2" name="batch_reprocessing" v-model="form.batch_reprocessing" @change="saveCompanyProfile($event)">
                                        <option value="ENABLED">ENABLED</option>
                                        <option value="DISABLED">DISABLED</option>
                                    </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="viewPage === null">
            <preLoader></preLoader>
        </template>
        <!-- <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template> -->
    </div>
    
</template>
<script>
    export default {
        data() {
            return {
                viewPage: null,
                heirarchyForm: new Form({
                    heirarchy_system: null,
                    makerList: [],
                    checkerList: [],
                    approverList: []
                }),
                form: new Form({
                    name:null,
                    walletID:null,
                    mca_id: null,
                    no_of_maker: null,
                    no_of_checker: null,
                    no_of_approver: null,
                    incomeTaxModule: '',
                    providentFundModule: '',
                    company_contribution_gross_salary: null,
                    pf_after_year: null,
                    pf_after_month: null,
                    pf_per_gross_salary:null,
                    shifts: null,
                    overtime: null,
                    overtime_percentage:null,
                    image: "",
                    heirarchy_system : '',
                    batch_reprocessing:'DISABLED'
                }),
                heirarchy_system : 'DISABLED',
                makerList : null,
                checkerList : null,
                approverList : null,
                makers : null,
                checkers : null,
                approvers : null,
                formdatavalue: {
                    field: null,
                    value: null,
                }
            }
        },
        watch: {
            heirarchy_system : function(newValue,oldValue){
                // if(newValue == 'ENABLED'){
                    this.populateMakerCheckerApprover();    
                // }
            }
        },
        updated() {
            $('.edit').on('click', function(){
                $(this).parent().parent().find('input').prop('disabled', false).focus();
                $(this).hide();
                $(this).siblings().show();   
            });
            $('.save').on('click', function(){
                $(this).parent().parent().find('input').prop('disabled', true).focus();
                $(this).hide();
                $(this).siblings().show();    
            });
        },
        mounted(){

            this.getCompanyProfile();

        },
        methods: {
            saveCompanyMakerCheckerApprover(){
                this.$Progress.start();
                this.heirarchyForm.heirarchy_system = this.heirarchy_system;
                var that = this;
                var selVal = '';
                this.heirarchyForm.makerList = [];
                $( "select.selectpicker.custom-select2.maker" ).each(function() {
                    selVal = $(this).find('option:selected').val();
                    that.heirarchyForm.makerList.push(selVal);
                    selVal = '';
                });
                this.heirarchyForm.checkerList = [];
                $( "select.selectpicker.custom-select2.checker" ).each(function() {
                    selVal = $(this).find('option:selected').val();
                    that.heirarchyForm.checkerList.push(selVal);
                    selVal = '';
                });
                this.heirarchyForm.approverList = [];
                $( "select.selectpicker.custom-select2.approver" ).each(function() {
                    selVal = $(this).find('option:selected').val();
                    that.heirarchyForm.approverList.push(selVal);
                    selVal = '';
                });
                axios.post('api/companyMakerCheckerApproverSubmit', this.heirarchyForm)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Details updated successfully');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                });
            },
            populateMakerCheckerApprover(){
                var that = this;
                var makerList = '<select class="selectpicker custom-select2 maker"><option value="">Select Maker</option>';
                this.makerList.forEach(function(value,index){
                    makerList += '<option value="'+value.id+'">'+value.name+'</option>';
                })
                makerList += '</select>';
                var checkerList = '<select class="selectpicker custom-select2 checker"><option value="">Select Checker</option>';
                this.checkerList.forEach(function(value,index){
                    checkerList += '<option value="'+value.id+'">'+value.name+'</option>';
                })
                checkerList += '</select>';
                var approverList = '<select class="selectpicker custom-select2 approver"><option value="">Select Approver</option>';
                this.approverList.forEach(function(value,index){
                    approverList += '<option value="'+value.id+'">'+value.name+'</option>';
                })
                approverList += '</select>';
                if(this.form.no_of_maker > 1){
                    var finalMakerList = '';
                    for(var i=0; i < this.form.no_of_maker; i++){
                        finalMakerList += makerList;
                    }
                    makerList = finalMakerList;
                }
                if(this.form.no_of_checker > 1){
                    var finalCheckerList = '';
                    for(var i=0; i < this.form.no_of_checker; i++){
                        finalCheckerList += checkerList;
                    }
                    checkerList = finalCheckerList;
                }
                if(this.form.no_of_approver > 1){
                    var finalApproverList = '';
                    for(var i=0; i < this.form.no_of_approver; i++){
                        finalApproverList += approverList;
                    }
                    approverList = finalApproverList;
                }
                $('div.maker').html(makerList);
                $('div.checker').html(checkerList);
                $('div.approver').html(approverList);
                $( "select.maker" ).each(function(index,value) {
                    if(typeof that.makers[index] !== 'undefined'){
                        var selected = that.makers[index].uid;
                        $(this).val(selected);
                    }
                });
                $( "select.checker" ).each(function(index,value) {
                    if(typeof that.checkers[index] !== 'undefined'){
                        var selected = that.checkers[index].uid;
                        $(this).val(selected);
                    }
                });
                $( "select.approver" ).each(function(index,value) {
                    if(typeof that.approvers[index] !== 'undefined'){
                        var selected = that.approvers[index].uid;
                        $(this).val(selected);
                    }
                });
                $('select.selectpicker').selectpicker();
            },
            onImageChange(e){
                this.form.image = e.target.files[0];
                this.formSubmit(e);
            },

            formSubmit(e) {
                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                formData.append('image', this.form.image);

                axios.post('api/updateCompanySettings', formData, config)
                .then(res => {
                    if(res.status == 200){
                        this.getCompanyProfile();
                        if($("#company-profile-img").length != 0){
                            $('#company-profile-img').attr('src',this.$global.aws_base_url+'/avatar/'+this.form.image.name);
                        }else{
                            $('.active-company-logo').html('<img id="company-profile-img" src="'+this.$global.aws_base_url+'/avatar/'+this.form.image.name+'">');                            
                        }
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Profile detail added successfully'
                        });
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            },

            submitMCA(e,id){
                this.form.mca_id = id;
                if(this.form.no_of_maker == '' || this.form.no_of_checker == '' || this.form.no_of_approver == '' || this.form.no_of_maker <= 0 || this.form.no_of_checker <= 0 || this.form.no_of_approver <= 0){
                    $(this).parent().parent().find('input').focus();
                    if(this.form.no_of_maker < 0){
                        this.showToastBox('error', 'Please fill the field Maker. Value must be greater than or equal to 1.');
                        return false;
                    }else if(this.form.no_of_checker < 0){
                        this.showToastBox('error', 'Please fill the field Checker. Value must be greater than or equal to 1.');
                        return false;
                    }else if(this.form.no_of_approver < 0){
                        this.showToastBox('error', 'Please fill the field Approver. Value must be greater than or equal to 1.');
                        return false;
                    }else{
                        this.showToastBox('error', 'Please fill the field. Value must be greater than or equal to 1.');
                        return false;
                    }
                }
                this.$Progress.start();
                axios.post('api/no_of_mca', this.form)
                .then(res => {
                    if(res.status == 200){
                        this.getCompanyProfile();
                        $(this).parent().parent().find('input').prop('disabled', true);
                        $(this).parent().hide();
                        $(this).parent().siblings().show();
                        this.$Progress.finish();
                        this.showToastBox('success','Details updated successfully');
                        this.populateMakerCheckerApprover();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            },

            getCompanyProfile(){
                this.$Progress.start();
                axios.get('/api/getCompanyProfile')
                .then(res => {
                    if(res.status == 200){
                        this.form = res.data.company;
                        this.makerList = res.data.makerList;
                        this.checkerList = res.data.checkerList;
                        this.approverList = res.data.approverList;
                        this.makers = res.data.makers;
                        this.checkers = res.data.checkers;
                        this.approvers = res.data.approvers;
                        this.viewPage = true;
                        var that = this;
                        setTimeout(function(){                            
                            that.heirarchy_system = (res.data.company.heirarchy_system == 'ON') ? 'ENABLED' : 'DISABLED';
                        },300);
                        this.$Progress.finish();
                    }else{                        
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                }).then(res=>{                    
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
                setTimeout(function(){
                    $('select.form-control.selectpicker.custom-select2').selectpicker('refresh');
                },3000);
            },

            showEdit(e) {
                
            },


            saveCompanyProfile(e) {
                if(e.target.nodeName == "SELECT"){
                    this.formdatavalue.field = $(e.target).parent().parent().find('select').attr('name');
                    this.formdatavalue.value = $(e.target).parent().parent().find('select').val();
                }else{
                    this.formdatavalue.field = $(e.target).parent().parent().parent().find('input').attr('name');
                    this.formdatavalue.value = $(e.target).parent().parent().parent().find('input').val();
                    if(this.formdatavalue.value.trim() == ''){
                        $(e.target).parent().parent().parent().find('input').focus();
                        this.showToastBox('error', 'Please fill the field');
                        return;
                    }
                }
                this.$Progress.start();
                axios.post('api/updateCompanySettings', this.formdatavalue)
                .then(res => {
                    if(res.status == 200){
                        this.getCompanyProfile();
                        this.$Progress.finish();
                        this.showToastBox('success', 'Profile detail added successfully');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });

            }

        }

    }
</script>

